module.exports = __webpack_public_path__ + "static/media/D1_C6_001.9c3ee7ec.png";